import { useEffect, useState } from "react";
import {
    Button,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

import {
    UpdateUserPermissionDto,
    UserDto
} from "../types/User";
import UserService from "../Services/UserService";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    user: UserDto;
    onSaved: () => void;
}

const PermissionModal = ({
    isOpen,
    toggle,
    user,
    onSaved
}: Props) => {

    const [permission,
        setPermission] =
        useState<UpdateUserPermissionDto>({
            isBlocked: false,
            isGroupChatAllow: true
        });

    useEffect(() => {

        if (!user) return;

        setPermission({
            isBlocked:
                user.isBlocked ?? false,

            isGroupChatAllow:
                user.isGroupChatAllow ?? true
        });

    }, [user]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const {
            name,
            checked
        } = e.target;

        setPermission(prev => ({
            ...prev,
            [name]: checked
        }));

    };

    const save = async () => {

        await UserService.updatePermissions(
            user.userID,
            permission
        );

        toggle();

        onSaved();

    };

    return (

        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            size="md"
        >

            <div>



                <ModalHeader
                    toggle={toggle}
                    style={{
                        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
                        color: "#fff",
                        padding: "18px 24px",
                        fontWeight: 700,
                        overflow: "hidden",
                        fontSize: "22px",
                    }}

                >
                    User Permissions
                </ModalHeader>

                <ModalBody>

                    <FormGroup check>

                        <Input
                            type="checkbox"
                            name="isGroupChatAllow"
                            checked={
                                permission.isGroupChatAllow ?? false
                            }
                            onChange={handleChange}
                        />

                        <Label check>
                            Allow Group Chat
                        </Label>

                    </FormGroup>

                    <FormGroup
                        check
                        className="mt-3"
                    >

                        <Input
                            type="checkbox"
                            name="isBlocked"
                            checked={
                                permission.isBlocked ?? false
                            }
                            onChange={handleChange}
                        />

                        <Label check>
                            Block User
                        </Label>

                    </FormGroup>

                </ModalBody>

                <ModalFooter>

                    <Button
                        style={{
                            background: "linear-gradient(135deg,#2563eb,#4f46e5)",
                            border: "none",
                            borderRadius: "10px",
                            padding: "10px 28px",
                            fontWeight: 600,
                            boxShadow: "0 8px 20px rgba(37,99,235,.25)",
                        }}
                        onClick={save}
                    >
                        💾 Save
                    </Button>

                    <Button
                        style={{
                            background: "#e2e8f0",
                            color: "#1e293b",
                            border: "none",
                            borderRadius: "10px",
                            padding: "10px 28px",
                            fontWeight: 600,
                        }}
                        onClick={toggle}
                    >
                        Cancel
                    </Button>

                </ModalFooter>

            </div>

        </Modal>

    );

};

export default PermissionModal;